module.exports = __webpack_public_path__ + "img/logo_f.8328b59d.png";